/* eslint-disable */
// GENERATED by scripts/generate-config.mjs - do not edit, do not commit.
// Source: the organizations list of config/customers/windward.json
import logo0 from "./logos/windward.generated.png";
import logo1 from "./logos/kimball.generated.png";
import favicon1 from "./logos/kimball.favicon.generated.png";

const organizations = [
  {
    id: "windward",
    name: "Windward Investors",
    shortName: "Windward",
    logo: logo0,
    logoAlt: "Windward Investors",
    favicon: null,
    palette: {},
    remitTo: {"name":"Windward Investors","lines":["2195 Pendley Road","Cumming, GA 30041"]},
  },
  {
    id: "kimball",
    name: "Roger Kimball Trucking",
    shortName: "Kimball",
    logo: logo1,
    logoAlt: "Roger Kimball Trucking",
    favicon: favicon1,
    palette: {"primary":"#000000","primaryContrastText":"#ffffff","secondary":"#2b2b2b","secondaryContrastText":"#ffffff","accent":"#6b6b6b","highlight":"#ffffff"},
    remitTo: {"name":"Roger Kimball Transportation Inc","lines":["2195 Pendley Road","Cumming, GA 30041"]},
  },
];

export default organizations;
